module.exports = __webpack_public_path__ + "img/market.df513ee2.png";